/**
 * Password reset. The third surface a session-less browser is allowed to sit on.
 *
 * The guard is the same one line every auth route carries: it leaves a signed-out visitor here and
 * forwards anyone who already holds a session to wherever that session belongs — a signed-in trainer
 * changes their password from inside the app, not through the recovery mail.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionRedirectFrom } from '~/entities/session';
import { ResetPasswordScreen } from '~/pages/reset-password';

export const Route = createFileRoute('/reset-password')({
  beforeLoad: () => {
    const destination = sessionRedirectFrom('/reset-password');
    // `throw: true` makes `redirect` raise the router's own Response itself. A bare `throw
    // redirect(...)` throws a non-Error, which is exactly what `only-throw-error` is there to catch.
    if (destination !== null) redirect({ to: destination, replace: true, throw: true });
  },
  component: ResetPasswordScreen,
});
